/**
 * 自营摄影即拍即传：当前摄影流程
①下单成功-自营摄影支付成功
②预约到店时间--摄影师给订单创建相册，视为预约流程结束，高亮现场拍摄
③现场拍摄--摄影师在后台确认交付照片视为本流程结束，高亮选择精修照片（如果相册被修改，订单关联不到相册，流程回退到预约拍摄）
④挑选精修照片--用户选择好精修照片进行提交视为本流程结束，高亮待修图师修照片 （备注：如需支付精修费用，精修费用支付成功视为本流程结束）
⑤修图师修照片--修图师后台上传精修照片并点击上传完成视为本流程结束，高亮下载精修照片
⑥精修照片交付
 */
export const PHOTO_STEP_ENUM = {
  ORDER_PAID: 1,
  PHOTO_RESERVE: 2,
  TAKE_PHOTO: 3,
  CHOSE_PHOTO: 4,
  MODIFY_PHOTO: 5,
  DOWNLOAD_PHOTO: 6
}

/* 相册照片选择场景 */
export const SELECT_MODE_ENUM = {
  NO_SELECT: '', //不选择
  DOWNLOAD_SELECT: 'download', //批量下载选择
  CHOSE_SELECT: 'chose', //选精修图选择
  VIEW_SELECT: 'view' //只显示已选择
}

export const NAMESPACE_SELF_PHOTO = 'selfPhoto'
export const PREFIX_CMS_999 = '//cms.cekid.com/publish/999/'
import {
  PREFIX_SUPLOAD_API,
  PREFIX_SOPERATION_API,
  PREFIX_STRADE_API
} from '@/service'

export const API = {
  URL_CMS_ALBUM: `${PREFIX_CMS_999}photography-config.json`, //自营摄影配置页
  URL_SAVERESERVEORDER: `${PREFIX_SOPERATION_API}reserve/saveReserveOrder.do`, // 新增/编辑预约单
  URL_QUERYRESERVEBYID: `${PREFIX_SOPERATION_API}reserve/getReserveInfoById.do`, // 根据id查询预约单
  URL_QUERYRESERVEDATELIST: `${PREFIX_SOPERATION_API}reserve/queryReserveDateTime.do`, // 批量查询预约时间点列表及库存B端(自营摄影)
  URL_QUERYRESERVECALENDAR: `${PREFIX_SOPERATION_API}reserve/queryReserveCalendar.do`, // 批量查询n个月日历库存(自营摄影)
  URL_QUERY_ALBUM_LIST_MINID: `${PREFIX_SUPLOAD_API}album/queryDetail.do`, //按下标查询相册列表
  URL_QUERY_ALBUM_LIST_PAGE: `${PREFIX_SUPLOAD_API}album/queryDetailAfterCommit.do`, //按页码查询相册列表
  URL_QUERY_ALBUM_LIST_SHARE: `${PREFIX_SUPLOAD_API}album/queryDetailsByToken.do`, // 分享页面相册明细
  URL_QUERY_ALBUM_INFO: `${PREFIX_SUPLOAD_API}album/getAlbumInfoApp.do`, //查询相册信息
  URL_POST_ALBUM_MODIFY: `${PREFIX_SUPLOAD_API}album/chooseRepair.do`, //选择精修照片
  URL_QUERY_TOKEN: `${PREFIX_SUPLOAD_API}album/getShareToken.do`, //【APP】获取分享token
  URL_CHECK_NEW_PHOTO: `${PREFIX_SUPLOAD_API}album/checkNewPhoto.do`, //校验是否有新照片
  URL_CREAT_ORDER_PHOTO: `${PREFIX_STRADE_API}strade/createAdditionOrder.do`
}
